<template>
  <UApp>
    <NuxtRouteAnnouncer />
    <NuxtLayout />
  </UApp>
</template>

<script setup lang="ts">
useColorMode()
</script>
